/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalizedText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";
// @ts-ignore
import WakesurfEdgeSelector from './../wake-shaper-finder/./wake-shaper-finder';


interface IProps {
  product?: any;
}

/**
 *
 * Description component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class WakesurfEdgeContent extends React.Component<IProps> {

  public render(): JSX.Element {
		let product:any = this.props.product;
    if(!product) return <span/>
    if(!product.attributes) return <span/>
    return (
			<div>
      {(product.attributes.slug == 'ballast-M6002' || product.attributes.slug == 'ballast-M6003' ) &&
          <span>
            <div className="dark-grey-background medium-padding">
              <div className="max-width-container">
                <WakesurfEdgeSelector />
              </div>
            </div>
            <div className="large-padding">
              <div className="row">
                <div className="small-12 medium-6">
                  <img className="full-width" src="https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MAbwvZ?pubver=1" />
                </div>
                <div className="small-12 medium-6">
                  <img className="full-width" src="https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MAbouB?pubver=1" />
                </div>
              </div>
            </div>
            <div className="small-padding">
              <h3 className="full-width centered-text">{'Downloads'}</h3>
              <div className="max-width-container">
                <div className="row">
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbwvT" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-angle-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Angle Guide'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbouy" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-common-mistakes-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Common Mistakes'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAblFn" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-hangtag-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Hangtag'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbwvW" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-location-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Location Guide'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbsqt" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-setup-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Setup Guide'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbqzx" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-shreducation-offer-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Shreducation Offer'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbqzu" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-marketing-copy-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'Marketing Copy'}</p>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-3 tiny-padding">
                    <div className="card light-grey-background">
                      <a style={{display:'block'}} href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAblFk" target="_blank">
                        <img className="full-width background-image-fill" src={GeneralAssetUrl+"rectangle.png"} style={{backgroundImage:'url('+GeneralAssetUrl+'wakeshaper-faq-thumb.jpg)'}} />
                        <p className="centered-text tiny-padding black">{'FAQ'}</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
          }
			</div>
		)
  }
}

export default WakesurfEdgeContent;
